import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const permissionApi = createApi({
  reducerPath: 'permissionApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['permission'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getRoleList: builder.query({
      query: () => ({
        method: 'GET',
        path: 'Roles/GetRoleNames',
      }),
      providesTags: ['permission'],
    }),
    getAllUsersRole: builder.query({
      query: () => ({
        method: 'GET',
        path: 'Roles/GetAllUsersRole',
      }),
      providesTags: ['permission'],
    }),
    setUserRole: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Roles/SetUserRole',
      }),
      invalidatesTags: ['permission'],
    }),
    clearUserRole: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `Roles/ClearUserRole/${id}`,
      }),
      invalidatesTags: ['permission'],
    }),
  }),
});

export const permissionApiReducerName = permissionApi.reducerPath;
export const permissionApiReducer = permissionApi.reducer;
export const permissionApiMiddleware = permissionApi.middleware;

export const {
  useGetRoleListQuery,
  useSetUserRoleMutation,
  useGetAllUsersRoleQuery,
  useClearUserRoleMutation,
} = permissionApi;
